import * as React from "react";

interface LabelTagProps {
  text?: string;
  className?: string;
  onClose?: React.MouseEventHandler<HTMLDivElement>;
  customCloseButton?: React.ReactNode;
  style?: React.CSSProperties;
}

export const LabelTag = ({
  text = "",
  className: classNameExt = "",
  onClose,
  customCloseButton,
  style = {},
}: LabelTagProps) => {
  let className =
    "bg-background-surface-neutral-subtle leading-none text-xs font-regular rounded-full px-2 py-1 inline-block";
  if (classNameExt) {
    className = `${className} ${classNameExt}`;
  }
  return (
    <div style={style} className={className} data-testid="li-react-label">
      {onClose ? (
        <div className="flex">
          <span>{text}</span>
          <div onClick={onClose} className="cursor-pointer" data-testid="remove-label">
            {customCloseButton ? customCloseButton : <i className="icon-lt-close-line ml-1" />}
          </div>
        </div>
      ) : (
        text
      )}
    </div>
  );
};
